/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    pre: "pre",
    code: "code",
    span: "span",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "TypeScriptである任意の範囲を表現する整数型を定義することを考えます。"), "\n", React.createElement(_components.p, null, "たとえば、1～12の範囲を表現する場合、以下のように書くことができます。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "MonthRange")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token number"
  }, "1"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "2"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "3"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "4"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "5"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "6"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "7"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "8"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "9"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "10"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "11"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token number"
  }, "12"), "\n")), "\n", React.createElement(_components.p, null, "これを以下のように書けると便利です。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "MonthRange")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token number"
  }, "1"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token number"
  }, "12"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, "このときの ", React.createElement(_components.code, null, "NumberRange"), " 型を定義してみます。"), "\n", React.createElement(_components.p, null, "話を簡単にするため、まずは 0 から任意の数までの連続した整数型を持つUnion型をつくる型を定義してみます。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                                             ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeArray型に渡す to"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                                        ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 繰り返した回数を記録する配列型（初期は空の配列型）"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token number"
  }, "0"), "                                                         ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeを再帰的に呼ぶので"), "\n                                                                ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 作成したUnion型の途中経過をW型に格納する"), "\n", React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token constant"
  }, "U")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "?"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token spread operator"
  }, "..."), React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, "U型と配列型Zの長さが一致するまで、W型にその時点での配列型Zの長さを整数型として追加していくという型定義です。\n", React.createElement(_components.code, null, "NumberRange"), "は再帰的に呼び出され、呼び出すたびに配列型Zに要素の型を追加していきます（配列の長さが変わればいいので、適当に ", React.createElement(_components.code, null, "true"), " 型の要素を追加しています）。配列型Zの長さとUが一致するまで繰り返されます。"), "\n", React.createElement(_components.p, null, "このとき、例えば以下のようにした場合、"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Month")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token number"
  }, "12"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, React.createElement(_components.code, null, "Month"), " 型は ", React.createElement(_components.code, null, "0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11"), " 型になります。(", React.createElement(_components.a, {
    href: "https://www.typescriptlang.org/play?#code/C4TwDgpgBAcgrgWwEYQE4CUCGA7A5hAHgCgooBVKCAD2AmwBMBnKbRFVAGlO597-4GCoAemGw2aLHggBBVKkwhA0eqBrBkCEdoE0GKMAD2JKAC1KNOk22o4EANoBdKAF4otrkNdu+oqIAc-QFEMgFfjAdQZAfQZAPbVAB1NAJIZADCjAJmSNQGiGQFlEwHQlJX0AdQcoAAZ3PPz8z3hkSRx8CMBYxUAGPUAQtxVAHxVANwZAOwZAcwZ9As6u109AHXlABCNgsmwASx1sJWbAFATAWjlAGV9AOQSI9NVAHgtAWF8EogA+LIMrAHIAGzpcYAALA7tqWgZmCgB+KEyALnESjDLCMi4rADoAQYuMALBAbFxMgAfQyHE54C5XbZEIigSBQACy4wuWWK7Ck+AIAEYAEzbIA"
  }, "TypeScript Playgroundで確認する"), ")"), "\n", React.createElement(_components.p, null, React.createElement(_components.code, null, "NumberRange"), " 型を発展させ、任意の数から任意の数までの連続した整数値を持つUnion型をつくる型に書き換えます。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "ArrayFixedLength"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "V"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token known-class-name class-name"
  }, "Array"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token known-class-name class-name"
  }, "Array"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " \n    ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token boolean"
  }, "true")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "?"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "V"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "ArrayFixedLength"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token spread operator"
  }, "..."), React.createElement(_components.span, {
    className: "token constant"
  }, "V"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token spread operator"
  }, "..."), React.createElement(_components.span, {
    className: "token constant"
  }, "W"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), " \n\n", React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "T"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                                             ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeArray型に渡す from"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                                             ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeArray型に渡す to"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "ArrayFixedLength"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                 ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 繰り返した回数を記録する配列型"), "\n                                                                ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 予め数列の始点分の配列型をセットしておく"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "T"), "                                                         ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeを再帰的に呼ぶので"), "\n                                                                ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 作成したUnion型の途中経過をW型に格納する"), "\n", React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token constant"
  }, "U")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "?"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token spread operator"
  }, "..."), React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, "（上記ソースコードにある ", React.createElement(_components.code, null, "ArrayFixedLength<T, U>"), " 型は、", React.createElement(_components.a, {
    href: "../20220824"
  }, "以前作った「任意の要素を持つ配列型」を生成する型定義"), "です。Tに指定した整数値分のU型の配列をつくります。）"), "\n", React.createElement(_components.p, null, React.createElement(_components.code, null, "NumberRange"), " 型のうち、配列型Zにはあらかじめ初期型として、長さTぶんの配列をセットしておくと、そのぶん", React.createElement(_components.code, null, "NumberRange"), "を再帰的に呼び出す回数が減ります。かつW型には初期値として数列の開始値Tをセットしておき、連続する整数値の開始時の値としています。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "MonthRange")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token number"
  }, "1"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token number"
  }, "12"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, "としたとき、 ", React.createElement(_components.code, null, "MonthRange"), " は ", React.createElement(_components.code, null, "1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11"), " 型となります。"), "\n", React.createElement(_components.p, null, "この型定義では、配列型Zの長さはU型と一致すると再帰呼び出しを終了するので、型「12」は含まれていません。(", React.createElement(_components.a, {
    href: "https://www.typescriptlang.org/play?#code/C4TwDgpgBAggTnAhiAYgSwB4QCYBkIB2A5sABYA8AKlBBsIdgM5QECuAtgEYRwA0UAVX4A1GnQbN4SEOQEA+KAF4oAbQC6-AOpj6BJrATJywOKwgLlKk2bUWoAKChOomlZTU6JUa9AD8UUQAuA2l0LDxCEgpKfiFVADpE4ViNBMTNfh9bB3tQSCgAOQ5uOAAlRGIIckcoalpdfTYuHn5nNvaOzq7upwB6XsLinnLKqWRAaPVAawZAQjtATQYoADM4AHt2GoFPPWYmktae-YOe-sHmsoqiCDGQKbnvZZqALU39H3UlEOQwnHxiMipM0zmPaHKDHQAOfoAohkAK-GAdQZAPoMgD21QAOpoAkhkAGFGAJmTZoBohkAsomAdCVxjUQSTSWTjoAIuUAgQxI-GAOwZANOagE6HQBgSnSCeMUYBuhkAwwyACYYYYAzBkAUgyAeQYatplNQyTLZX0BkVTiMLijALGKgAY9QAhbpNAD4qgDcGOmAcwZiXLTXLjoAdeUACEbwgQENDLAjjOmAFATALRygBlfQByCSjNFNADwWgFhfHH2OwPFQAcgANpEyBGPPUvBt-NpgoqSsqqjFBPwVIl4g8ATYtFAAD5QcPR2OkeNyez1vLQACyjrI73Tw3OVQAjPxuwAmORAA"
  }, "TypeScript Playgroundで確認する"), ")"), "\n", React.createElement(_components.p, null, "これだと使いづらいので、さらに改善していきます。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "T"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                                             ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeArray型に渡す from"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                                             ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeArray型に渡す to"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "Y"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "unknown"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token spread operator"
  }, "..."), React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "ArrayFixedLength"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "   ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 終了条件を判定する型"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "ArrayFixedLength"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), "                 ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 繰り返した回数を記録する配列型"), "\n  ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "T"), "                                                         ", React.createElement(_components.span, {
    className: "token comment"
  }, "// NumberRangeを再帰的に呼ぶので"), "\n                                                                ", React.createElement(_components.span, {
    className: "token comment"
  }, "// 作成したUnion型の途中経過をW型に格納する"), "\n", React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token constant"
  }, "Y")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "?"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRange"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Y"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token spread operator"
  }, "..."), React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "true"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "W"), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "|"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "Z"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "'length'"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, "Y型は、長さ(U+1)の配列型です。配列型Yの長さと配列型Zの長さを比較するように修正することで、先ほどの終了条件（Uと配列型Zの長さ）よりも1回多く処理を実行できます。(", React.createElement(_components.a, {
    href: "https://www.typescriptlang.org/play?#code/C4TwDgpgBAggTnAhiAYgSwB4QCYBkIB2A5sABYA8AKlBBsIdgM5QECuAtgEYRwA0UAVX4A1GnQbN4SEOQEA+KAF4oAbQC6-AOpj6BJrATJywOKwgLlKk2bUWoAKChOomlZTU6JUa9AD8UUQAuA2l0LDxCEgpKfiFVADpE4ViNBMTNfh9bB3tQSCgAOQ5uOAAlRGIIckcoalpdfTYuHn5nNvaOzq7upwB6XsLinnLKqWRAaPVAawZAQjtATQYoADM4AHt2GoFPPWYmktae-YOe-sHmsoqiCDGQKbnvZZqATU39VgIAawJlgHcCdSU0+JXMI4fDEMiyTKmcyQmx7Y6AIV9AGFygENzQBvcoAkhkAJEqALO1ZoBohnGNQAWs9mD4-sogZgQZFwTFvFC5HtDlBjoAHP0AUQyAFfjAOoMgH0GQB7aoAHU3RgAwowBMyfjALKJgHQlQlObTKagslWq-bHIqnEYXdGAWMVAAx6gBC3SaAHxVAG4MgDsGQDmDDU1Xb7V1joAdeUACEb8gQENDLAjjC2AFATALRygBlfQByCejNFNADwWgFhffH2OxElQAcgANrTSEmPPUvA9k2mwRmPP5tMFNSVtVV6XEHvwVIl4kSYRBUtoAD5QROp9OZuT2Pt5aAAWW9ZH+ZeG5yqAEZ+FOAExyIA"
  }, "TypeScript Playgroundで確認する"), ")"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "type"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "MonthRange")), " ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberRangeArray"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token number"
  }, "1"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token number"
  }, "12"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n")), "\n", React.createElement(_components.p, null, "としたとき、", React.createElement(_components.code, null, "MonthRange"), " 型は ", React.createElement(_components.code, null, "1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12"), " 型になり、期待した結果が得られました。"), "\n", React.createElement(_components.p, null, "たのしい型パズルの様子をお届けしました。ではでは～"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
